import { render, staticRenderFns } from "./pointClass.vue?vue&type=template&id=0bfca75a&scoped=true&"
import script from "./pointClass.vue?vue&type=script&lang=js&"
export * from "./pointClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfca75a",
  null
  
)

export default component.exports